import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';

import App from './App';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
